import {BaseComponent} from "../BaseComponent/BaseComponent";
export default BaseComponent;